import { render } from "./emission.vue?vue&type=template&id=1f5a5e2b"
import script from "./emission.vue?vue&type=script&lang=js"
export * from "./emission.vue?vue&type=script&lang=js"

import "./emission.vue?vue&type=style&index=0&id=1f5a5e2b&lang=scss"

import exportComponent from "/home/manohar/Bhutan_gitlab/tethysapp-airqualitybt/tethysapp/airqualitybt/vairqualitybt/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__